import { useEffect } from 'react'
import { Route, Routes, useLocation, useNavigationType } from 'react-router-dom'

import ArticlePage from './pages/Article'
import CategoryPage from './pages/Category'
import HomePage from './pages/Home'
import NotFoundPage from './pages/NotFound'
import SearchPage from './pages/Search'

/**
 * A link to another page starts it at the top: without this a category opened
 * from the foot of the home page showed its own foot. Back and forward keep
 * the browser's restored position, and a #section link is left to the page
 * that owns the anchor.
 */
function ScrollToTopOnNavigate() {
  const { pathname, hash } = useLocation()
  const navigationType = useNavigationType()
  useEffect(() => {
    if (navigationType !== 'POP' && !hash) window.scrollTo({ top: 0 })
  }, [pathname]) // eslint-disable-line react-hooks/exhaustive-deps
  return null
}

export default function App() {
  return (
    <>
      <ScrollToTopOnNavigate />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/categories/:slug" element={<CategoryPage />} />
        <Route path="/articles/:id" element={<ArticlePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  )
}
